function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./gmark-editor.twig";
import "./gmark-editor.scss";
import GMarkBlock from "./gmark-block.brick";
import GMarkSelect from "./gmark-select.brick";
var GmarkEditorBrick = (_dec = Brick.renderOnConstruct(false), _dec2 = Brick.register('gmark-editor', twig), _dec3 = Brick.listen('gmark-block-dragend'), _dec4 = Brick.listen('gmark-block-dragged'), _dec5 = Brick.listen('gmark-block-drop'), _dec6 = Brick.listen('add-new-block'), _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(GmarkEditorBrick, _Brick);

  var _super = _createSuper(GmarkEditorBrick);

  function GmarkEditorBrick() {
    _classCallCheck(this, GmarkEditorBrick);

    return _super.apply(this, arguments);
  }

  _createClass(GmarkEditorBrick, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.dragged = null;
    }
  }, {
    key: "value",
    get: function get() {
      var value = [];
      this.$('[is="gmark-block"]').each(function (block) {
        return value.push(block.controller.toString());
      });
      return value.join("\n\n");
    },
    set: function set(value) {
      var _this = this;

      if (typeof value !== "string") value = null;
      var blocks = this.parse(value);
      blocks.forEach(function (block) {
        return _this.addBlock(block);
      });
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(args) {
      this.gmark = args.attributes.gmark;
      this.value = args.value;
    }
  }, {
    key: "dragEnd",
    value: function dragEnd(event) {
      this.dragged = null;
      event.cancel();
    }
  }, {
    key: "dragStart",
    value: function dragStart(event) {
      this.dragged = event.source;
      event.cancel();
    }
  }, {
    key: "dragDrop",
    value: function dragDrop(event) {
      if (this.dragged !== null) {
        this.placeBlock(this.dragged, event.source);
      }

      event.cancel();
    }
  }, {
    key: "addNewBlock",
    value: function addNewBlock(event) {
      var _this2 = this;

      var after = event.source;

      if (event.source.controller === this) {
        after = this.$$('add-block').node;
      }

      GMarkSelect.modalify(this.gmark, function (command) {
        if (command === null) return;
        var block = {
          command: _this2.gmark[command],
          attributes: [],
          body: ''
        };
        GMarkBlock.create('div').then(function (newblock) {
          newblock.setup(block);

          _this2.placeBlock(newblock.root, after);
        });
      });
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      return _get(_getPrototypeOf(GmarkEditorBrick.prototype), "setOptions", this).call(this, options);
    }
  }, {
    key: "parse",
    value: function parse(text) {
      var _this3 = this;

      if (text === null || text.trim() === '') return [];
      text = text.replace(/\n{3,}/g, "\n\n").trim();
      var blocks = [];
      var lines = text.split("\n");
      var firstcommand = lines[0].split(' ')[0];

      if (typeof this.gmark[firstcommand] === 'undefined') {
        blocks.push({
          command: null,
          attributes: {},
          body: text
        });
      } else {
        var parts = text.toString().split("\n\n");
        parts.forEach(function (part) {
          // find command
          var lines = part.split("\n");
          var commandline = lines.shift();
          var command = commandline.split(' ')[0];

          if (typeof _this3.gmark[command] === 'undefined' && blocks.length) {
            blocks[blocks.length - 1].body += "\n\n" + part;
          } else {
            var attributes = [];
            var attrstring = commandline.substr(command.length);

            if (attrstring) {
              var t = document.createElement('div');
              t.innerHTML = '<div ' + attrstring + '></div>';
              var attrNames = t.childNodes[0].getAttributeNames();
              attrNames.forEach(function (attrName) {
                attributes[attrName] = t.childNodes[0].getAttribute(attrName);
              });
            }

            blocks.push({
              command: _this3.gmark[command],
              attributes: attributes,
              body: lines.join("\n")
            });
          }
        });
      }

      return blocks;
    }
  }, {
    key: "addBlock",
    value: function addBlock(block) {
      var _this4 = this;

      GMarkBlock.create('div').then(function (newblock) {
        newblock.setup(block);

        _this4.placeBlock(newblock.root);
      });
    }
  }, {
    key: "placeBlock",
    value: function placeBlock(block) {
      var after = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (after === null) this.$$('blocks').node.appendChild(block);else after.after(block);
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this5 = this;

      this.$$('add-block').listen('click', function (event) {
        _this5.fire('add-new-block');
      });
    }
  }]);

  return GmarkEditorBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "dragEnd", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "dragEnd"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dragStart", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "dragStart"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dragDrop", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "dragDrop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addNewBlock", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "addNewBlock"), _class2.prototype)), _class2)) || _class) || _class);
export { GmarkEditorBrick as default };